import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="This page lists all orders that are awaiting fulfillment or approval. Review pending items and take action as needed." id="this_page_lists_all_orders_that_are_awai.39df18b8" />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Viewing Pending Orders" id="viewing_pending_orders.b0fdce6b" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the <strong>Fill Inventory</strong> or <strong>Fill New Order</strong> actions to process pending orders and allocate licenses." id="use_the_fill_inventory_or_fill_new_order.9aaf1737" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Fulfilling Orders" id="fulfilling_orders.5cccdde0" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Cancel a pending order if it is no longer needed. <strong>Cancelled orders cannot be reinstated.</strong>" id="cancel_a_pending_order_if_it_is_no_longe.3b6cec72" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Cancelling Orders" id="cancelling_orders.d780792b" />
        }
    ],
    title: <FormattedMessage defaultMessage="Pending Orders" id="pending_orders.abd66f4e" />
};
